var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col" }, [
      _c(
        "h5",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "text-success" }, [
            _c("i", {
              staticClass: "fa fa-check-circle text-success",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(
              "\n                " +
                _vm._s(_vm.trans.title_convertion_done) +
                ":"
            ),
            _c("br"),
            _vm._v(" "),
            _c("b", [
              _vm._v(
                _vm._s(_vm.voucherCredits) + " " + _vm._s(_vm.trans.credits)
              ),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col mt-4" }, [
      _c("a", { on: { click: _vm.redeemMoreVoucher } }, [
        _vm._v(_vm._s(_vm.trans.convert_more)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }